export const REPORT_FILTERS = [
  { id: 'review', name: 'Комментарии' },
  { id: 'photo', name: 'Фотографии' },
  { id: 'article', name: 'Информация' },
  { id: 'itIsMyOrganization', name: 'Собственники' },
  { id: 'organization', name: 'Организации' },
  { id: 'event', name: 'Мероприятия' },
];

export const REPORT_MODAL_STATES = {
  viewPhoto: 'viewPhoto',
  decline: 'decline',
  approve: 'approve',
  seen: 'seen',
};
